import React from "react";

import BlogHero from "../components/blog/BlogHero";
import BlogGrid from "../components/blog/BlogGrid";

import SectionContainer from "../components/common/SectionContainer";
import SectionTitle from "../components/common/SectionTitle";

import CTASection from "../components/sections/CTASection";

function BlogPage() {
  return (
    <>
      <BlogHero />

      <SectionContainer background="#ffffff">
        <SectionTitle
          title="Latest Articles"
          subtitle="Practical growth, marketing and technology insights for ambitious organizations."
        />

        <BlogGrid />
      </SectionContainer>

      <CTASection />
    </>
  );
}

export default BlogPage;